



































import AbpBase from "@/lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import util from '@/lib/util'
import {
  GetBindingLaboratoryCategoriesList,
  GetLaboratoryCategoriesList,
  GetLaboratoryIndicatorsList,
  BatchSaveBindingLaboratoryCategorie
} from "@/api/laboratoryCategories";
@Component({components: { }})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    title="";
    fuzzyQuery="";
    bingdings:any=[];
    indicators:any=[];
    indicatorsAll:any=[];
    selectedTableRow:any=[];
    selectedTable2Row:any=[];
    editBingdingData:any={};
    editShow=false;
    loading=false;
    categoriesColumn = [
         {
            type: "selection",
            width: 60,
            align: "center",
        },
         {
            title: "指标编码",
            key: "itemCode",
            minWidth: 120,
        },
        {
            title: "指标名称",
            key: "itemName",
            minWidth: 120,
        },
        {
            title: "单位",
            key: "unit",
            width: 80,
        },
        {
            title: "样本",
            key: "sampleClass",
            minWidth: 80,
        },
        {
            title: "最大值",
            key: "maximum",
            width: 120,
        },
        {
            title: "最小值",
            key: "minimum",
            width: 120,
        },
        {
            title: "排序码",
            key: "sortNum",
            width: 120,
        },
    ];

    bingdingColumn = [
    {
        type: "selection",
        width: 60,
        align: "center",
    },
    {
        title: "指标编码",
        key: "itemCode",
        minWidth: 120,
    },
    {
        title: "指标名称",
        key: "itemName",
        minWidth: 120,
    },
    {
        title: "单位",
        key: "unit",
        width: 80,
    },
    {
        title: "样本",
        key: "sampleClass",
        minWidth: 120,
    },
    {
        title: "换算",
        key: "conversion",
        width: 70,
    },
    {
        title: "值类型",
        key: "valueType",
        width: 80,
    },
    {
    title: "操作",
    width: 180,
    render: (h1: any, params: any) => {
        const h = this.$createElement;
        let isdefaultDom: any;
        return h("div", [
            isdefaultDom,
            h(
                "Button",
                {
                props: { type: "error", size: "small" },
                on: {
                    click: () => {
                        this.delData(params.row,params.index);
                    },
                },
                },
                "删除"
            ),
            ]);
        },
        },
    ];
    //表格高度
    get tableHeight() {
        return window.innerHeight - 200;
    }
    async created() 
    {
        this.title = this.data.largeCategoryName +" 调整";
        this.getData();
    }
    async createdData(){
        let res2 = await GetBindingLaboratoryCategoriesList({
            categoriesId: this.data.categoriesId,
        });
          if (res2 && res2.objects) {
            this.bingdings = res2.objects;
        } else {
            this.bingdings = [];
        }
        this.$nextTick(() => {
            this.screenCategorie();
        });
    }
    //获取数据
    async getData(){
        this.selectedTableRow=[];
        this.selectedTable2Row=[];
        let res = await GetLaboratoryIndicatorsList({queryString:this.fuzzyQuery});
        if (res && res.objects) {
            this.indicatorsAll = res.objects;
        } else {
            this.indicatorsAll = [];
        }
        this.$nextTick(() => {
            this.createdData();
        });
    }
    cancel() {
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
        this.$emit("input", value);
        }
    }
    //单个删除
    async delData(row:any,index:number){
        this.$Modal.confirm({
        title: "提示",
        content: "此操作将永久删除该指标, 是否继续?",
            onOk: async () => {
                this.bingdings.splice(index, 1)
                this.screenCategorie();
            },
        });
    }
    //筛选指标
    screenCategorie(){
        this.selectedTableRow=[];
        this.selectedTable2Row=[];
        let idList = this.bingdings.map((row) => {
            return row.indicatorsId;
        });
        this.indicators = this.indicatorsAll.filter((x) => idList.indexOf(x.id)==-1);
    }
    async refreshData(){
        if(this.editBingdingData.saveType=="批量添加"){
            let bingdingList = this.selectedTableRow.map((row) => {
                return row;
            });
            bingdingList.forEach(item => {
                this.bingdings.push({
                    itemCode:item.itemCode,
                    itemName:item.itemName,
                    unit:item.unit,
                    sampleClass:item.sampleClass,
                    conversion:item.conversion,
                    valueType:item.valueType,
                    indicatorsId :item.id,
                    categoriesId:this.data.categoriesId
                })
            });
            this.screenCategorie();
        }
    }
    //勾选
    tableSelectionChange(selection: any) {
        this.selectedTableRow = selection;
    }
    //勾选
    tableSelectionChange2(selection: any) {
        this.selectedTable2Row = selection;
    }
    //批量删除
    async batchDelete(){
            this.$Modal.confirm({
            title: "提示",
            content: "此操作将永久删除勾选的指标, 是否继续?",
            onOk: async () => {
                let idList = this.bingdings.map((row) => {
                    return row.indicatorsId;
                });
                this.bingdings = this.bingdings.filter((item) => 
                   idList.indexOf(item.indicatorsId)==-1
                );
                this.screenCategorie();
            },
        });
    }
    //批量绑定
    batchBingding()
    {
        if(this.selectedTableRow.length<=0) {
            this.$Message.error("请勾选需要的指标！");
            return;
        }
        this.editBingdingData = Object.assign({},this.data);
        this.editBingdingData.saveType="批量添加";
        this.refreshData();
    }
    async save(){
        this.loading=true;
        let data ={
            categoriesId:this.data.categoriesId,
            bingdings:this.bingdings
        }
        let res = await BatchSaveBindingLaboratoryCategorie(data)
        if(res.status==1){
            this.$emit('input',false);
            this.$emit('on-success')
        }
        this.loading=false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/laboratoryCategories/bindingLaboratoryCategories.vue